// Copyright (c) 2020 Deere & Company

import PinTransferDataCollections, { getDefaultState } from '../state/pinTransferDataCollections';
import actions from '../../../../sharedmodules/actions-list';

const getUserDelaerMappedData = (state, action) => PinTransferDataCollections.update(state, {
    $set: action.data.length > 0 ? action.data : getDefaultState(),
});

const resetUserDelaerMappedData = (state) => PinTransferDataCollections.update(state, {
    $set: getDefaultState(),
});

const updateTransferComment = (state, action) => {

    const updatedTransfers = [...state];

    const index = state.findIndex((transfer) => transfer.id === action.data.id);

    if (index === -1) {

        return state;

    }

    updatedTransfers.splice(index, 1, action.data);

    return PinTransferDataCollections.update(state, {
        $set: updatedTransfers,
    });

};
export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.GET_DEALER_PIN_TRANSFER_DATA]: getUserDelaerMappedData,
        [actions.RESET_DEALER_PIN_TRANSFER_DATA]: resetUserDelaerMappedData,
        [actions.UPDATE_TRANSFER_COMMENT_SUCCESS]: updateTransferComment,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
